import { Clock, LinearToneMapping, LoadingManager, PMREMGenerator, WebGLRenderer } from "three";
import Stats from "three/examples/jsm/libs/stats.module";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { CameraController } from "../componets3D/CameraController";
import { sizedcanvasHome } from "../../helpers/Constnats";
import hdri from "../../assets/hdri/provence_studio_1k.hdr";
import { CharcterOxxo } from "./objects/CharacterOxxo";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import {
	MainScene,
	SceneIntroducion,
	SceneTopicOne,
	SceneTopicTwo,
	SceneTopicThree,
	SceneTopicFour,
	SceneTopicFive,
} from "./scene";
import { sceneNumbers } from "./scene/typeScenes";

let deltasum = 0;
let interval = 1 / 60;

export class App {
	constructor(container, pointsTootltips) {
		this.container = container;
		this.loadingManager = new LoadingManager();
		this.clock = new Clock();
		this.renderer = new WebGLRenderer({ antialias: true, alpha: true });
		this.renderer.setPixelRatio(window.devicePixelRatio);
		//
		this.container.appendChild(this.renderer.domElement);
		this.camera = new CameraController(
			60,
			this.container.clientWidth / this.container.clientHeight,
			0.1,
			500,
			this.container,
			this.renderer.domElement
		);
		this.camera.position.set(-1.534, 226, 300);

		this.actualScene = 0;
		this.selectedCharacterIntroduction = {
			after: -1,
			before: -1
		}

		this.loadingHDRI();
		// * creacion de scenas para las actividades
		this.mainScene = new MainScene(this.container, this.loadingManager);
		//* theme
		this.sceneIntroduction = null;
		this.sceneTopicOne = null
		this.sceneTopicTwo = null
		this.sceneTopicThree = null
		this.sceneTopicFour = null
		this.sceneTopicFive = null

		// model selected

		//
		this.stats = new Stats();
		this.stats.showPanel(0);
		this.stats.domElement.style.cssText = "position:absolute;bottom: 0;right:0px;";
		document.body.appendChild(this.stats.dom);
		//
		this.onResized();
		this.loadingProyectEvents();
		this.listenEmitters();
		window.addEventListener(
			"resize",
			() => {
				this.onResized();
				setTimeout(() => {
					this.onResized();
				}, 500);
			},
			{ passive: true }
		);
	}
	onLoadCharcater(callback) {
		if (this.characterSelected) {
			callback();
		} else {
			const loadingManagerCharacter = new LoadingManager();
			const idCharacter = parseInt(localStorage.getItem("character"));
			if (idCharacter) {
				this.characterSelected = new CharcterOxxo(loadingManagerCharacter, idCharacter, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
			} else {
				this.characterSelected = new CharcterOxxo(loadingManagerCharacter, 1, { x: -50, y: -50, z: 3.6 }, { x: 0, y: 1.4, z: 0 });
			}
			loadingManagerCharacter.onLoad = () => {
				callback();
			};
		}
	}

	onResized() {
		this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
		this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
		this.camera.updateProjectionMatrix();
	}

	loadingHDRI() {
		const loderhdr = new RGBELoader(this.loadingManager);
		loderhdr.load(hdri, (texture) => {
			const pmremGenerator = new PMREMGenerator(this.renderer);
			var envMap = pmremGenerator.fromEquirectangular(texture).texture;

			this.environmentToScenes = envMap;

			texture.dispose();
			pmremGenerator.dispose();
		});
		this.renderer.toneMapping = LinearToneMapping;
		this.renderer.toneMappingExposure = 0.58;
		// var gui = new GUI();
		// gui.add(this.renderer, "toneMappingExposure", 0, 2).step(0.01).name("Exposure");
	}

	loadingProyectEvents() {
		this.loadingManager.onLoad = () => {
			// loading complete
			this.mainScene.environment = this.environmentToScenes;
			ObserverEmitter.emit(EVENTS.loadingComplete);
			this.mainScene.SceneInitialState();
			this.render();
		};
	}

	animationToRescaleRenderer(scale = 0) {
		const data = {
			iniposition: window.innerWidth,
		};
		gsap.timeline().to(data, {
			duration: 0.3,
			iniposition: window.innerWidth - scale,
			onUpdate: () => {
				this.renderer.setSize(data.iniposition, this.container.clientHeight);
				this.camera.aspect = data.iniposition / this.container.clientHeight;
				this.camera.updateProjectionMatrix();
			},
		});
	}

	listenEmitters() {
		// * move to main menu
		ObserverEmitter.on(EVENTS.back_to_main, () => {
			if (this.actualScene !== 0) {
				this.actualScene = sceneNumbers.initMainMenu
				this.animationToRescaleRenderer(sizedcanvasHome);
				this.mainScene.moveMain()
			}
		});
		ObserverEmitter.on(EVENTS.init_mainMenu, () => {
			this.actualScene = sceneNumbers.initMainMenu;
			this.animationToRescaleRenderer(sizedcanvasHome);
			this.mainScene.SceneInitialState();
		});
		//* introduccion
		ObserverEmitter.on(EVENTS.tema6.introduction, (activity) => {
			this.loadingIntroduction(() => {
				this.actualScene = sceneNumbers.introduction;
				this.animationToRescaleRenderer();
				this.sceneIntroduction.SceneInitialState();
				this.sceneIntroduction.ActivitiSelected(activity);
			});
		});
		//* Topic One
		ObserverEmitter.on(EVENTS.tema6.topic1.initScene, (activity) => {
			this.loadingTopicOne(() => {
				this.actualScene = sceneNumbers.topicOne;
				this.animationToRescaleRenderer();
				this.sceneTopicOne.ActivitiSelected(activity);
			});
		});
		//* Topic two
		ObserverEmitter.on(EVENTS.tema6.topic2.initScene, (activity) => {
			this.loadingTopicTwo(() => {
				this.actualScene = sceneNumbers.topicTwo;
				this.animationToRescaleRenderer();
				this.sceneTopicTwo.ActivitiSelected(activity);
			});
		});
		//* Topic three
		ObserverEmitter.on(EVENTS.tema6.topic3.initScene, (activity) => {
			this.loadingTopicThree(() => {
				this.actualScene = sceneNumbers.topicThree;
				this.animationToRescaleRenderer();
				this.sceneTopicThree.ActivitiSelected(activity);
			});
		});
		//* Topic four
		ObserverEmitter.on(EVENTS.tema6.topic4.initScene, (activity) => {
			this.loadingTopicFour(() => {
				this.actualScene = sceneNumbers.topicFour;
				this.animationToRescaleRenderer();
				this.sceneTopicFour.ActivitiSelected(activity);
			});
		});
		//* Topic five
		ObserverEmitter.on(EVENTS.tema6.topic5.initScene, (activity) => {
			this.loadingTopicFive(() => {
				this.actualScene = sceneNumbers.topicFive;
				this.animationToRescaleRenderer();
				this.sceneTopicFive.ActivitiSelected(activity);
			});
		});
	}

	loadingIntroduction(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneIntroduction) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneIntroduction = new SceneIntroducion(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes,
					this.selectedCharacterIntroduction
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTopicOne(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicOne) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicOne = new SceneTopicOne(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes,
					this.selectedCharacterIntroduction
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTopicTwo(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicTwo) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicTwo = new SceneTopicTwo(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes,
					this.selectedCharacterIntroduction
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTopicThree(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicThree) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicThree = new SceneTopicThree(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes,
					this.selectedCharacterIntroduction
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTopicFour(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicFour) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicFour = new SceneTopicFour(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes,
					this.selectedCharacterIntroduction
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}

	loadingTopicFive(callback) {
		ObserverEmitter.emit(EVENTS.initLoadingScene);
		if (this.sceneTopicFive) {
			ObserverEmitter.emit(EVENTS.loadingCompleteScene);
			callback();
		} else {
			this.onLoadCharcater(() => {
				const loadingManagerTopic = new LoadingManager();
				this.sceneTopicFive = new SceneTopicFive(
					loadingManagerTopic,
					this.container,
					this.renderer,
					this.characterSelected,
					this.environmentToScenes,
					this.selectedCharacterIntroduction
				);
				loadingManagerTopic.onLoad = () => {
					ObserverEmitter.emit(EVENTS.loadingCompleteScene);
					callback();
				};
			});
		}
	}


	render() {
		const delta = this.clock.getDelta();
		deltasum += delta;

		// requestAnimationFrame(this.render);
		if (deltasum > interval) {
			let sceneToRender;

			switch (this.actualScene) {
				case sceneNumbers.initMainMenu:
					sceneToRender = this.mainScene;
					break;
				case sceneNumbers.introduction:
					sceneToRender = this.sceneIntroduction;
					break;
				case sceneNumbers.topicOne:
					sceneToRender = this.sceneTopicOne;
					break;
				case sceneNumbers.topicTwo:
					sceneToRender = this.sceneTopicTwo;
					break;
				case sceneNumbers.topicThree:
					sceneToRender = this.sceneTopicThree;
					break;
				case sceneNumbers.topicFour:
					sceneToRender = this.sceneTopicFour;
					break;
				case sceneNumbers.topicFive:
					sceneToRender = this.sceneTopicFive;
					break;
				default:
					sceneToRender = this.mainScene;
					break;
			}

			this.renderer.render(sceneToRender, this.camera);
			sceneToRender.renderAnimations(deltasum);
			this.camera.update(deltasum);

			if (this.characterSelected) {
				// this.characterSelected.renderAnimations(deltasum, this.camera);
				this.characterSelected.renderAnimations(deltasum, null);
			}

			this.stats.update();

			deltasum = deltasum % interval;
		}
		requestAnimationFrame(() => this.render());
	}
}
